
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 3h2v5h-2V3zM7.5 6.094l3.563 3.531-1.438 1.438L6.094 7.5zm17 0L25.906 7.5l-3.531 3.563-1.438-1.438zM16 9c3.854 0 7 3.146 7 7s-3.146 7-7 7-7-3.146-7-7 3.146-7 7-7zm0 2c-2.773 0-5 2.227-5 5s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5zM3 15h5v2H3v-2zm21 0h5v2h-5v-2zM9.625 20.938l1.438 1.438L7.5 25.907l-1.406-1.406zm12.75 0l3.531 3.563-1.406 1.406-3.563-3.531zM15 24h2v5h-2v-5z"}})])
          )
        }
      }
    